import axios from 'axios'
import notifService from '../../services/notifService'

export const getActivity = async (context, val) => {
  return await axios
    .get('/cms/dashboard/activity/default')
    .then(response => {
      context.commit('getActivity', response.data.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const getAdvActivity = async (context, val) => {
  return await axios
    .get('/cms/dashboard/activity/filter', { params: val })
    .then(response => {
      let res = response.data.data
      context.commit('getAdvance', res)
      if (Array.isArray(res) && res.length) return 'ok'
      else {
        notifService.notif('apiRes', 'Data dashboard tidak tersedia.', 'warn')
        return 'error'
      }
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const getAdvSales = async (context, val) => {
  return await axios
    .get('/cms/dashboard/activity/sales', { params: val })
    .then(response => {
      let res = response.data.data

      if (!res.target) {
        notifService.notif('apiRes', 'Data target belum ditentukan', 'warn')
        return false
      }

      return res
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const setFilter = (context, val) => {
  context.commit('setFilter', val)
}

export const setSales = (context, val) => {
  context.commit('setSales', val)
}

export const getSales = async (context, val) => {
  return await axios
    .get('/cms/dashboard/activity', { params: val })
    .then(response => {
      context.commit('getSales', response.data.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const addTarget = async (context, val) => {
  return await axios
    .post('/cms/target-sales/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const editTarget = async (context, val) => {
  return await axios
    .put('/cms/target-sales/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const deleteTarget = async (context, val) => {
  return await axios
    .delete('/cms/target-sales/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const getGeoCustomer = async (context, val) => {
  return await axios
    .get('/cms/dashboard/geo/customers', { params: val })
    .then(response => {
      context.commit('getGeoCustomer', response.data.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const setGeoCustomer = async (context, val) => {
  context.commit('setGeoCustomer', val)
}

export const selectGeoCustomer = async (context, val) => {
  let data = context.state.geoCustomer
  let temp = []
  data.forEach(d => {
    if (val.region == 'district_id') {
      if (d.district_id == val.id) temp.push(d)
    } else {
      if (d.province_id == val.id) temp.push(d)
    }
  })

  context.dispatch('setGeoCustomer', temp)

  await axios
    .get('/cms/dashboard/geo/customers/region', { params: val })
    .then(response => {
      context.commit('selectGeoCustomer', response.data.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  context.dispatch('setGeoCustomer', temp)
}

export const getGeoPB = async (context, val) => {
  return await axios
    .get('/cms/dashboard/geo/pb', { params: val })
    .then(response => {
      context.commit('getGeoPB', response.data.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const setGeoPB = async (context, val) => {
  context.commit('setGeoPB', val)
}

export const selectGeoPB = async (context, val) => {
  let data = context.state.geoPB
  let temp = []
  data.forEach(d => {
    if (val.region > 0) {
      if (d.district_id == val.id) temp.push(d)
    } else {
      if (d.province_id == val.id) temp.push(d)
    }
  })

  context.dispatch('setGeoPB', temp)
}

export const getRegion = async (context, val) => {
  return await axios
    .get('/cms/dashboard/geo/regions', { params: val })
    .then(response => {
      context.commit('getRegion', response.data.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const getGeoInstrument = async (context, val) => {
  return await axios
    .get('/cms/dashboard/geo/instruments', { params: val })
    .then(response => {
      context.commit('getGeoInstrument', response.data.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const setGeoInstrument = async (context, val) => {
  context.commit('setGeoInstrument', val)
}

export const selectGeoInstrument = async (context, val) => {
  let data = context.state.geoInstrument
  let temp = []
  data.forEach(d => {
    if (val.region > 0) {
      if (d.district_id == val.id) temp.push(d)
    } else {
      if (d.province_id == val.id) temp.push(d)
    }
  })

  context.dispatch('setGeoInstrument', temp)
}
